<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Model Inferencing</ion-title>
    <ion-buttons slot="end">
      <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
      <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title> -->
      <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
  </ion-buttons>
  </ion-toolbar>
</ion-header>



<ion-content>
  
  <ng-container>

    <ion-card class="card-hover-effect fixed-button" (click)="openModelInferencingFormModal()">
        <ion-card-header style="cursor: pointer;">
          <ion-card-title>New record</ion-card-title>
        </ion-card-header>
    </ion-card>
    
    <form [formGroup]="ttsForm">

      <ion-grid>
        

        <ion-row>

          <ion-col size="2">
              <ion-item class="form-item">
                <ion-label position="floating">Language:</ion-label>
                <!-- <ion-select name="lang" formControlName="lang" required (ionChange)="onLanguageChange($event)" interface="popover"> -->
                <ion-select name="lang" formControlName="lang" required (ionChange)="onLanguageChange($event)">
                  <ion-select-option value="nl" selected>Dutch</ion-select-option>
                  <ion-select-option value="en">English</ion-select-option>
                </ion-select>
              </ion-item>
          </ion-col>
          <ion-col size="2">
              <ion-item class="form-item">
                <ion-label position="floating">Model Name:</ion-label>
                <!-- <ion-select name="model_name" formControlName="model_name" required (ionChange)="onModelChange($event)" interface="popover"> -->
                <ion-select name="model_name" formControlName="model_name" required (ionChange)="onModelChange($event)">
                  <ion-select-option *ngFor="let model of modelList" [value]="model">
                    {{ model }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
          </ion-col>

          <ion-col size="2">
            <ion-item class="form-item">
              <ion-label position="floating">Text Type:</ion-label>
                <ion-select name="text_type" formControlName="text_type" required (ionChange)="onTextTypeValueChange($event)">
                  <ion-select-option value="custom_text" selected>Custom</ion-select-option>
                  <ion-select-option value="mozilla_text">Mozilla</ion-select-option>
                </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="2">
            <ion-item class="form-item">
              <ion-label position="floating">AI Test:</ion-label>
              <!-- <ion-select name="model_name" formControlName="model_name" required (ionChange)="onModelChange($event)"> -->
                <ion-select name="filter_value" formControlName="filter_value" required (ionChange)="onFilterValueChange($event)">
                  <ion-select-option value="all" selected>All</ion-select-option>
                  <ion-select-option value="not_matched">Failed</ion-select-option>
                  <ion-select-option value="matched">Succeed</ion-select-option>

                </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="2">
            <ion-item class="form-item">
              <ion-label position="floating">Usability Filter:</ion-label>
                <ion-select name="usability" formControlName="usability" required (ionChange)="onUsableFilterValueChange($event)">
                  <ion-select-option value="all" selected>All</ion-select-option>
                  <ion-select-option value="usable">Usable</ion-select-option>
                  <ion-select-option value="not_usable">Not Usable</ion-select-option>
                </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="2">
            <ion-item class="form-item">
              <ion-label position="floating">Verified Filter:</ion-label>
                <ion-select name="verified" formControlName="verified" required (ionChange)="onVerifiedFilterValueChange($event)">
                  <ion-select-option value="all" selected>All</ion-select-option>
                  <ion-select-option value="verified">Verified</ion-select-option>
                  <ion-select-option value="not_verified">Not Verified</ion-select-option>
                </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="6">
          </ion-col>

          <ion-col size="3">
            <ion-item class="form-item">
              <ion-input formControlName="searchQuery" placeholder="Search..." (ionInput)="onSearchInputChange()" (keyup.enter)="onSearch()"></ion-input>
              <ion-icon class="search-icon" name="search" slot="end" title="search" (click)="onSearch()"></ion-icon>
              <ion-icon class="clear-icon" name="close-circle" slot="end" *ngIf="ttsForm.get('searchQuery')?.value" (click)="clearSearch()"></ion-icon>
            </ion-item>
          </ion-col>



        </ion-row>
        <!-- <ion-row>
          <ion-col size="3"></ion-col>
              <ion-col>
              <ion-list> -->

                <!-- <ion-item class="form-item" [style.visibility]="toggleValue ? 'hidden' : 'visible'"> -->
                <!-- <ion-item class="form-item" *ngIf="!toggleValue">
                  <ion-label position="floating">Message:</ion-label>
                  <ion-input 
                    formControlName="message"
                    type="text" 
                    required 
                    [(ngModel)]="formData.message" 
                    name="message">
                    
                  </ion-input>
                  
                
                </ion-item> -->

                <!-- <ion-col class="toggle-container">
                    <ion-checkbox style="margin-right: 10px;margin-left: 8px;"  (ionChange)="onToggleChange($event)">Generate Audio for All Text:</ion-checkbox>

                </ion-col> -->

<!-- 
              <div *ngIf="audioError" class="audio-error-message">
                <span style="color: red;">Error loading Text. Please try again with different Message.</span>
              </div> -->

              
              
              <!-- <ion-button type="submit" expand="block" class="submit-button" [disabled]="!ttsForm.valid && !toggleValue">Submit</ion-button> -->
              <!-- </ion-list>
              </ion-col>
            <ion-col size="3"></ion-col>
        </ion-row> -->
      </ion-grid>
      <!-- <ion-row class="custom-margin">
      </ion-row> -->
        

      <ion-grid>

          
      </ion-grid>

    
    </form>

    <!-- <ion-button type="submit" expand="block" class="submit-button" [disabled]="!ttsForm.valid">Submit</ion-button> -->

    <!-- <ion-grid>
      <ion-row *ngFor="let item of audioResponseList">
        <ion-col size="8">
          <ion-card>
            <ion-card-content>
              <p>{{ urlChangeToText(item) }}</p>
              <h3>URL</h3>

              <p>
                <audio controls>
                  <source [src]="item" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </p>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid> -->

  

    
    <ion-grid style="margin-top: -70px;">
      <ion-row *ngIf="!Audiopath && !audioData" class="ion-align-items-center ion-justify-content-center">
        <ion-col size="10" size-md="6">
          <ion-card>
            <ion-card-header>
              <ion-card-title>No audio data available.</ion-card-title>
            </ion-card-header>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid id="targetSection">
      <ion-row *ngIf="Audiopath" class="ion-align-items-center ion-justify-content-center">
        <ion-col size="10" size-md="6">
          <ion-card>
            <ion-card-header>
              <ion-card-title>{{formData.message}}</ion-card-title>

              <ion-row class="audio-container">
                <ion-col>
                  <audio controls class="audio-player" #audioPlayer>
                    <source [src]="Audiopath" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </ion-col>
              </ion-row>

              <!-- <div style="display: flex; align-items: center; gap: 10px;padding-left: 1px;" *ngIf="Audiopath">
                <input type="text" class="custom-input" placeholder="Enter Mispronounced words here ..." 
                       (input)="checkInput1(mispronouncedInput1.value)" #mispronouncedInput1/>
                <button class="custom-button" (click)="postMispronounced(item, mispronouncedInput1,0)" 
                        [disabled]="isDisabledSingle">Post</button>
              </div> -->

            </ion-card-header>
          </ion-card>
        </ion-col>
      </ion-row>


      <ion-row *ngFor="let item of audioResponseList; let i = index" class="ion-align-items-center ion-justify-content-center">
        <ion-col size="10" size-md="6">
          <ion-card>
            <ion-card-header>
              <!-- Top Right Verified Checkbox -->
              <div style="position: absolute; top: 10px; right: 10px; display: flex; align-items: center;">
                <span style="font-size: small;">Verified</span>
                <ion-checkbox style="margin-left: 5px;" [checked]="getMetadata(item)?.verified" (ionChange)="toggleVerified(item, $event)"></ion-checkbox>
              </div>

              <ion-card-title style="margin-top: 15px;">{{getMetadata(item)?.text || urlChangeToText(item) }}</ion-card-title>

              <div class="audio-container">
                <audio controls preload="none">
                  <source [src]="item" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>


              <div *ngIf="getMetadata(item)">
                <!-- Usability:  -->
                <!-- <ion-toggle [checked]="getMetadata(item)?.usability" (ionChange)="toggleUsability(item, $event)"></ion-toggle> -->
                <ion-checkbox style="margin-right: 10px;" [checked]="getMetadata(item)?.usability" (ionChange)="toggleUsability(item, $event)">Usability:</ion-checkbox>
                <ion-checkbox [checked]="getMetadata(item)?.intonation" (ionChange)="toggleIntonation(item, $event)">Intonation:</ion-checkbox>

                <!-- <span style="margin-right: 5px;">Intonation:</span>
                <ion-checkbox
                    style="margin-right: 10px; vertical-align: middle;"
                    [checked]="getMetadata(item)?.intonation"
                    (ionChange)="toggleIntonation(item, $event)"
                  ></ion-checkbox> -->

              </div>

              <div style="display: flex; align-items: center;">
                <!-- Remarks: "{{ getMetadata(item)?.remarks || 'No remarks available' }}" -->
                Remarks: {{ getMetadata(item)?.remarks ? getMetadata(item)?.remarks : 'No remarks' }}
                <ion-button fill="clear" size="small" (click)="openEditPopup(item,getMetadata(item)?.remarks ? getMetadata(item)?.remarks : '')">
                  <ion-icon name="create-outline"></ion-icon>
                </ion-button>
              </div>

              <div style="display: flex; align-items: center;">
                <!-- Remarks: "{{ getMetadata(item)?.remarks || 'No remarks available' }}" -->
                Mispronounced words: {{ getMetadata(item)?.mispronounced_words ? getMetadata(item)?.mispronounced_words : '' }}
                 <!-- Mispronounced Words: {{mispronouncedWordsValueToDisplay}} -->
                <!-- <ion-button fill="clear" size="small" (click)="openEditPopup(item)">
                  <ion-icon name="create-outline"></ion-icon>
                </ion-button> -->
              </div>

              <div style="display: flex; align-items: center;margin-top: 7px;">
                <!-- Remarks: "{{ getMetadata(item)?.remarks || 'No remarks available' }}" -->
                Not recorded mispronounced words: {{ getMetadata(item)?.not_recorded_mispronounced_words ? getMetadata(item)?.not_recorded_mispronounced_words : '' }}
                <!-- Not Recorded misspronounced words: {{ notrecordedMispronounceWordsToDisplay}} -->
                
                <!-- <ion-button fill="clear" size="small" (click)="openEditPopup(item)">
                  <ion-icon name="create-outline"></ion-icon>
                </ion-button> -->
              </div>


              
              <div *ngIf="!getMetadata(item)?.automation_passed" style="display: flex; align-items: flex-start;margin-top: 7px;">
                <span style="color: red;">Model&nbsp;transcription:&nbsp;</span>
                {{ getMetadata(item)?.model_transcription ? getMetadata(item)?.model_transcription : '' }} 
              </div>
              <div *ngIf="!getMetadata(item)?.automation_passed" style="display: flex; align-items: center;margin-top: 7px;">
                <span style="color: red;">Error rate:&nbsp;</span>
                 {{ getMetadata(item)?.error_rate ? getMetadata(item)?.error_rate + '%' : '' }} 
              </div>

              <!-- <div style="display: flex; align-items: center;margin-top: 7px;"> -->
                <!-- Not recorded mispronounced words: {{ getMetadata(item)?.not_recorded_mispronounced_words ? getMetadata(item)?.not_recorded_mispronounced_words : '' }} -->
                <!-- <ion-button fill="clear" size="small">
                  <ion-icon name="create-outline"></ion-icon>
                </ion-button>
              </div>-->
              <!-- <div style="display: flex; align-items: center; margin-top: 7px;">
                <ion-button fill="clear" size="small">
                   history
                </ion-button>
              </div>
              <div style="display: flex; align-items: center; margin-top: 7px;">
                <ion-button fill="clear" size="small" color="medium">
                  History
                </ion-button>
              </div> -->

              <!-- <ion-button fill="solid" color="primary">History</ion-button> -->
              <ion-button fill="solid" color="primary" style="margin-top: 8px;margin-left: 0px;" (click)="openModelInferencingHistory(i,item,urlChangeToText(item))">
                History
              </ion-button>
              
              <!-- <ion-button fill="outline" style="background: white; color: black; box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);">
                History
              </ion-button> -->
              

              
              
              

                    <!-- <div style="display: flex; align-items: center; gap: 10px;">
                      <input type="text" class="custom-input" placeholder="Enter Mispronounced words here ..." (input)="checkInput(mispronouncedInput, i)"  #mispronouncedInput/>
                      <button class="custom-button" (click)="postMispronounced(item, mispronouncedInput,i)" [disabled]="isButtonDisabled.get(i) ?? true">Post</button>
                    </div> -->

                    <!-- <ion-button expand="full" (click)="openFormModal()">Open Form</ion-button> -->
                    <!-- <button class="custom-button" (click)="openFormModal()">Mispronounced words</button> -->

                    
                    
        
                    <!-- <div style="position: relative; height: 0px;">
                      <div style="position: absolute; right: 0; bottom: 0; display: flex; align-items: center;">
                        <ion-button style="color: currentcolor;" fill="clear" size="small" (click)="openEditPopup(item)">
                        +
                        </ion-button>
                      </div>
                    </div> -->
                    
                    <div style="cursor: pointer;" class="icon-container">
                      <ion-icon name="add" class="plus-icon" (click)="openFormModal(i,item)"></ion-icon>
                    </div>
                    

                    <!-- <ion-card class="my-card"> -->
                      <!-- <ion-icon name="add" class="plus-icon"></ion-icon> -->
                    <!-- </ion-card> -->
<!--                     
                    <div style="position: relative; min-height: 0px;background-color: white;opacity: 100;">
                      <div style="position: absolute; right: 0px; bottom: 0px; display: flex; align-items: right;background-color: white;">
                        <ion-item lines="none" style="background-color:  white;">
                          <ion-icon style="background-color: white;" slot="end" name="add-outline"></ion-icon>
                        </ion-item>
                        
                      </div>
                    </div> -->

                    <!-- <div style="position: relative; min-height: 0px;">
                      <div style="position: absolute; right: 0px; bottom: 0px; display: flex; align-items: center; background: inherit; padding: 4px; border-radius: 8px;">
                        <ion-item lines="none" style="background: inherit; --ion-background-color: transparent;">
                          <ion-icon slot="end" name="add-outline" style="background: inherit; padding: 8px; border-radius: 4px;"></ion-icon>
                        </ion-item>
                      </div>
                    </div>
                     -->

                    <!-- <div style="position: relative; min-height: 0px; background-color: white;">
                      <div style="position: absolute; right: 0px; bottom: 0px; display: flex; align-items: center; background-color: white; border-radius: 8px; padding: 4px;">
                        <ion-item lines="none" style="background-color: white; --ion-background-color: white;">
                          <ion-icon slot="end" name="add-outline" style="background-color: white; padding: 4px; border-radius: 4px;"></ion-icon>
                        </ion-item>
                      </div>
                    </div> -->
                    
                    
                    
              


              
              

              
            </ion-card-header>
            <ion-card-content>
              
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
      <div style="margin-bottom: 70px;"></div>
    </ion-grid>

  


    <!-- footer implemented -->
    <ion-footer class="pagination-footer">
      <ion-toolbar>
        <ion-row justify-content-center align-items-center class="pagination-row">
          <!-- First Page Button -->
          <ion-col size="auto" class="text-center">
            <ion-button fill="solid" color="primary" (click)="goToPage(1)" [disabled]="currentPage <= 1">First</ion-button>
            <!-- <ion-button fill="solid" color="primary">First</ion-button> -->
          </ion-col>
    
          <!-- Previous Page Button -->
          <ion-col size="auto" class="text-center">
            <ion-button fill="solid" color="primary" (click)="goToPage(currentPage - 1)" [disabled]="currentPage <= 1">
            <!-- <ion-button fill="solid" color="primary"> -->
              Previous
            </ion-button>
          </ion-col>
    
          <ion-col size="auto" class="text-center">
            <ion-item lines="none" class="input-container">
              <div>
                <!-- <ion-label>
                  {{ goToPageNumber }} / {{ totalPages }}
                </ion-label> -->
                <!-- <ion-input type="number" [(ngModel)]="goToPageNumber" placeholder="Page #" min="1" [max]="totalPages"> -->
    
                <!-- </ion-input> -->
                  <span class="page-info">{{ goToPageNumber || 1 }} / {{ totalPages }}</span>
                  <!-- <span class="page-info">1/256</span> -->
    
                <!-- <p class="page-info">
                   {{ goToPageNumber || 1 }} / {{ totalPages }}
                </p> -->
              </div>
            </ion-item>
            <!-- <ion-button fill="solid" color="primary" (click)="goToSpecificPage()" [disabled]="!goToPageNumber || goToPageNumber < 1 || goToPageNumber > totalPages">
              Go
            </ion-button> -->
          </ion-col>
    
          <!-- Page Number Buttons -->
          <!-- <ion-col size="auto" class="text-center">
            <ion-buttons>
              <ion-button *ngFor="let page of getPages()" (click)="goToPage(page)">
                {{ page }}
              </ion-button>
            </ion-buttons>
          </ion-col> -->
    
          <!-- Next Page Button -->
          <ion-col size="auto" class="text-center">
            <ion-button fill="solid" color="primary" (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages">
            <!-- <ion-button fill="solid" color="primary"> -->
              Next
            </ion-button>
          </ion-col>
    
          <!-- Last Page Button -->
          <ion-col size="auto" class="text-center">
            <ion-button fill="solid" color="primary" (click)="goToPage(totalPages)" [disabled]="currentPage >= totalPages">
              Last
            </ion-button>
          </ion-col>
    
          <!-- Go to Page Input -->
          <ion-col size="auto" class="text-center">
            <ion-item lines="none" class="input-container">
              <ion-input type="number" [(ngModel)]="goToPageNumber" (keydown)="onKeyPress($event)" placeholder="Page #" min="1" [max]="totalPages"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="auto" class="text-center">
            <ion-button fill="solid" color="primary" (click)="goToSpecificPage()" [disabled]="!goToPageNumber || goToPageNumber < 1 || goToPageNumber > totalPages || totalPages ===1">
              Go
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-footer>
    
    
    
  </ng-container>
</ion-content>
